/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { computed } from '@ember/object';
import { comparisonOperators } from 'cio/utils/operators';
import AttributeCondition from 'cio/app-models/conditions/attribute';
import EventAttributeCondition from 'cio/app-models/conditions/event-attribute';
import CollectionAttributeCondition from 'cio/app-models/conditions/collection-attribute';
import DeviceAttributeCondition from 'cio/app-models/conditions/device-attribute';
import FormEventAttributeCondition from 'cio/app-models/conditions/form-event-attribute';
import CampaignModel from 'cio/models/campaign';
import { ModelType } from 'cio/utils/conversions';
import { ConditionType } from 'cio/utils/condition-types';
import { isEmpty } from '@ember/utils';
import {
  operatorsWithoutEventTypes,
  removeEventComparisonOperator,
  valueAndEventOperatorsOnly,
} from 'cio/utils/condition-editor';

interface ComparisonOperatorArgs {
  condition?:
    | AttributeCondition
    | EventAttributeCondition
    | CollectionAttributeCondition
    | DeviceAttributeCondition
    | FormEventAttributeCondition;
  campaign?: CampaignModel;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  size?: string;
  variation?: string;
  fluid?: boolean;
  modelType: ModelType;
}

export default class ComparisonOperator extends Component<ComparisonOperatorArgs> {
  get isForeignEventFilterAttribute() {
    if (this.args.condition instanceof EventAttributeCondition) {
      return this.args.condition.isForeignEventFilterAttribute;
    }

    return false;
  }

  get isEventTriggeredCampaign() {
    return this.args.campaign?.isEventTriggered ?? false;
  }

  get event() {
    return this.args.condition?.event ?? '';
  }

  get type() {
    return this.args.condition?.type ?? null;
  }

  @computed('args.condition.{type,event}', 'args.campaign.isWebhookTriggered')
  get selectItems() {
    let items = [...comparisonOperators];

    if (this.args.campaign?.isWebhookTriggered ?? false) {
      return valueAndEventOperatorsOnly(items);
    }

    if (this.type !== null && isEmpty(this.event)) {
      let isAttributeOrCollectionAttribute = [ConditionType.Attribute, ConditionType.CollectionAttribute].includes(
        this.type as ConditionType,
      );
      if (isAttributeOrCollectionAttribute) {
        return items.filter((operator) => operatorsWithoutEventTypes(operator.value));
      }
    }

    if (this.args.condition?.isConversionEventAttribute != null) {
      if (this.args.modelType === ModelType.Newsletter || !this.isEventTriggeredCampaign) {
        return removeEventComparisonOperator(items);
      }
      return items;
    }

    return items;
  }
}
